import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
    <path d="M3.26291 4.19419L0.77392 0.983815C0.621091 0.786691 0.761582 0.5 1.01101 0.5H5.98899C6.23842 0.5 6.37891 0.786691 6.22608 0.983815L3.73709 4.19419C3.61699 4.34911 3.38301 4.34911 3.26291 4.19419Z" fill="currentColor" />
  </svg>
);

